module.exports = __webpack_public_path__ + "img/introduction-nocar.5a60b064.jpg";